<app-header
  class="header"
  coreActivitySection="Header"
  [pageName]="`Menu ${menu().name}`"
  [backSwipe]="backSwipeConfig"
>
  <app-header-text slot="center" [text]="menu().name"/>
</app-header>

<app-scroll>
  <div class="pages">
    @for (url of menu().pagesLocal; track url) {
      <core-menu-image [url]="url"/>
    }
  </div>
</app-scroll>
